import React, { useState } from 'react';
import { redirectToLogin } from '../utils/auth';

interface LoginPopupProps {
  onLogin?: () => void;
}

const LoginPopup: React.FC<LoginPopupProps> = ({ onLogin }) => {
  const [isLoggingIn, setIsLoggingIn] = useState(false);
  const [email, setEmail] = useState('');

  const handleLogin = () => {
    setIsLoggingIn(true);
    if (onLogin) {
      onLogin();
    }
    redirectToLogin(email.trim() || undefined);
  };

  return (
    <div className="login-popup-overlay">
      <div className="login-popup">
        <div className="login-popup-content">
          <h1>Welcome!</h1>
          <p>Please sign in with your company account.</p>
          <input
            type="email"
            className="email-input"
            placeholder="Enter your email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            disabled={isLoggingIn}
            autoComplete="email"
            name="email"
            onKeyDown={(e) => {
              if (e.key === 'Enter') {
                handleLogin();
              }
            }}
          />
          <button
            className="login-button"
            onClick={handleLogin}
            disabled={isLoggingIn}
          >
            {isLoggingIn ? (
              <>
                <div className="login-spinner"></div>
                Redirecting...
              </>
            ) : (
              <>
                Sign In
              </>
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default LoginPopup;
